<template>
  <div class="steps">
    <div class="step" v-for="(item, index) in stepsList" :key="index">
      <h6
        class="title"
        :style="{'color': stepsActive >= index ? activeColor : '#333'}"
      >{{item.title}}</h6>
      <p class="desc" v-html="item.desc"></p>
      <div
        class="line"
        :style="{'background': stepsActive > index ? activeColor : '#D7D7D7'}"
      ></div>
      <div
        class="spot"
        :style="{'background': stepsActive >= index ? activeColor : '#D7D7D7'}"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Steps',
  props: {
    stepsList: {
      type: Array
    },
    stepsActive: {
      type: Number,
      default: 0
    },
    activeColor: {
      type: String,
      default: '#00BC7A'
    }
  },
  data() {
    return {

    }
  },

}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}
.step {
  position: relative;
  padding: 0 0 50px 40px;
}
.step .title {
  font-size: 28px;
  line-height: 40px;
}
.step .desc {
  margin-top: 8px;
  font-size: 26px;
  line-height: 40px;
  color: #999;
}
.step .spot {
  position: absolute;
  left: 0;
  top: 10px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
}
.step .line {
  position: absolute;
  top: 10px;
  left: 10px;
  width: 2px;
  height: 100%;
}
.steps .step:nth-last-of-type(1) .line {display: none;}
</style>